import { makeStyles, tokens } from '@fluentui/react-components';

export const useRouteLinkStyles = makeStyles({
    inverted: {
        color: tokens.colorNeutralForegroundInverted,
        ':hover': {
            color: tokens.colorNeutralForegroundInvertedHover
        },
        '@media screen and (max-width: 1500px)': {
            fontSize: tokens.fontSizeBase200,
            lineHeight: tokens.lineHeightBase200
        },
        '@media screen and (max-width: 1400px)': {
            fontSize: tokens.fontSizeBase100,
            lineHeight: tokens.lineHeightBase100
        }
    }
});
